<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <form [formGroup]="addForm" enctype="multipart/form-data">
      <div class="form-group">
        <label>اســـم الدورة التدربية</label>
        <input
          formControlName="tittle"
          [class.is-invalid]="tittle.invalid && tittle.touched"
          type="text"
          class="form-control"
        />
        <div *ngIf="tittle.errors && tittle.invalid && tittle.touched">
          <small class="text-danger" *ngIf="tittle.errors?.required">
            اســـم الدورة التدربية مطلوب
          </small>
        </div>
      </div>

      <div class="form-group">
        <label>وصــــف الدورة التدربية</label>
        <input
          type="text"
          [class.is-invalid]="description.invalid && description.touched"
          formControlName="description"
          class="form-control"
        />
        <small
          class="text-danger"
          [class.d-none]="description.valid || description.untouched"
        >
          وصــــف الدورة التدربية غير صحيحة
        </small>
      </div>
      <div class="form-group">
        <label>القســـــــم </label>
        <select class="custom-select" formControlName="categoryID">
          <option
            *ngFor="let category of categories"
            value="{{ category._id }}"
          >
            {{ category.Title }}
          </option>
        </select>
      </div>
      
       <div class="form-group row d-flex justify-content-between align-items-center mt-3">
        <div class="progress col-lg-3 mt-3" *ngIf="existingFile">
          <div
            class="progress-bar progress-bar-striped bg-danger"
            attr.aria-valuenow="{{ progress }}"
            aria-valuemin="0"
            aria-valuemax="100"
            [ngStyle]="{ width: progress + '%' }"
          >
            {{ progress }}%
          </div>
        </div>

        <label class="btn btn-default col-lg-3 mt-3">
          <input type="file" (change)="chooseFile($event)" />
        </label>

        <img class="img-fluid col-lg-3 mt-3"
          src="https://khairokom-uploadfiles.azurewebsites.net/files/{{
            fileName
          }}"            
        />

        <button
          class="upload btn btn-primary col-lg-2 mt-3"
          [disabled]="!chosenFiles"
          (click)="upload()"
        >
          رفع الصـــورة
        </button>

        <div class="alert alert-light">{{ msg }}</div>
      </div>

      <input
        type="submit"
        class="add btn btn-primary"
        value="إضافة"
        (click)="submit()"
      />
    </form>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
